/**
 * @module store/marathons/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetMarathons, apiDeleteMarathons, apiSetMarathon } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Получеие страницы со стартами
 *
 * @since Version 1.0.0
 */
const getMarathons = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_MARATHONS_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetMarathons(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_MARATHONS_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список стартов.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_MARATHONS_ASYNC.FAILURE);
  }
};


/**
 * Action: Delete emails
 *
 * @since Version 1.0.1
 */
const deleteMarathons = async ({ rootGetters }, marathons) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeleteMarathons(userSession.accessToken.jwtToken, marathons);
    } else {
      throw new Error('Неавторизованный пользователь не может удалять старты.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set foundation
 *
 * @since Version 1.0.3
 */
const setMarathon = async ({ rootGetters }, marathon) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetMarathon(userSession.accessToken.jwtToken, marathon);
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию о стартах.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  deleteMarathons,
  getMarathons,
  setMarathon,
};
